// extracted by mini-css-extract-plugin
module.exports = {"ProductTabs":"ProductTabs_ProductTabs__1CLsD","ProductTabsItem":"ProductTabs_ProductTabsItem__3ehnB","Active":"ProductTabs_Active__npUaP"};